module.exports = {
  content: ["./src/**/*.{ts,tsx,html}"],
  theme: {
    // screens: {
    //   sm: "480px",
    //   md: "768px",
    //   lg: "976px",
    //   xl: "1440px",
    // },
    colors: {
      blue: "#0669F4",
      blueLight: "#85CCF8",
      white: "#FFFFFF",
      black: "#000000",
      grey: "#D6D6D6",
      red: "#FF0000",
      // purple: "#7e5bef",
      // pink: "#ff49db",
      // orange: "#ff7849",
      // green: "#13ce66",
      // yellow: "#ffc82c",
      // "gray-dark": "#273444",
      // gray: "#8492a6",
      // "gray-light": "#d3dce6",
    },
    fontFamily: {
      // NOTE: this overrides the default font used throughout the lib.
      sans: ["Poppins"],
    },
    extend: {
      boxShadow: {
        button: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        "focus-glow": "0 0 2px 2px #85CCF8",
      },
    },
  },
  variants: {
    extend: {
      boxShadow: ["focus"],
    },
  },
  plugins: [],
};
